/* eslint-disable no-lonely-if */
/* eslint-disable prefer-destructuring */
import * as marietta from '../../..';
import { ITEM_MODE_NO } from '../../Constants';
import { SVGSprite } from '../../flash/display';

export default class FittingGuide {
  public spt: SVGSprite;

  viewObj: Element;

  lineObj: Element;

  wallLneObj1: Element;

  wallLneObj2: Element;

  textObj: Element;

  textboxObj: Element;

  wallTextboxObj1: Element;

  wallTextboxObj2: Element;

  transformMatrix: string;

  index: number;

  parentObj: marietta.webcad.item.MonicaObject;

  text: string;

  wallText1: string;

  wallText2: string;

  refElem1: Element;

  refElem2: Element;

  refElem3: Element;

  refElem4: Element;

  wallStartDot: marietta.core.Point;

  wallEndDot: marietta.core.Point;

  wallStartGlobalPoint: marietta.core.Point;

  wallEndGlobalPoint: marietta.core.Point;

  _firstDot: marietta.core.Point;

  fontSize: number;

  textboxObjWidth: number;

  textboxObjHeight: number;

  textboxWidth: number;

  textboxHeight: number;

  textboxPadding: number;

  guideLinePadding: number;

  guideLineY: number;

  private readonly MAX_BOX_HEIGHT: number;

  private readonly MAX_FONT_SIZE: number;

  get firstDot() {
    return this._firstDot;
  }

  set firstDot(_dot: marietta.core.Point) {
    this._firstDot = _dot;
    this.updateTransforms();
  }

  _secondDot: marietta.core.Point;

  get secondDot() {
    return this._secondDot;
  }

  set secondDot(_dot: marietta.core.Point) {
    this._secondDot = _dot;
    this.updateTransforms();
  }

  previouseInfo: marietta.webcad.collection.ItemInfoCollection;

  constructor(targetNode: Element) {
    this.textboxObjWidth = 40;
    this.textboxObjHeight = 18;
    this.textboxWidth = 60;
    this.textboxHeight = 16;
    this.fontSize = 12;
    this.textboxPadding = 8;
    this.guideLinePadding = 2;
    this.guideLineY = 25;
    this.MAX_BOX_HEIGHT = 11;
    this.MAX_FONT_SIZE = 9;
    this.viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.viewObj.id = 'fitingGuide';
    // ラインの作成
    this.lineObj = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this.lineObj.setAttribute('stroke', '#2d2d2e');
    this.lineObj.setAttribute('stroke-width', '1');
    this.lineObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(10, 10)));
    this.lineObj.setAttribute('id', 'fittingGuidLine');
    this.lineObj.setAttribute('vector-effect', 'non-scaling-stroke');
    this.viewObj.appendChild(this.lineObj);
    this.refElem1 = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.refElem2 = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    const line1 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line1.setAttribute('stroke', '#2d2d2e');
    line1.setAttribute('stroke-width', '0.5');
    line1.setAttribute('vector-effect', 'non-scaling-stroke');
    const line2 = line1.cloneNode();
    this.refElem1.appendChild(line1);
    this.refElem1.appendChild(line2);

    const line3 = line1.cloneNode();
    const line4 = line1.cloneNode();

    this.refElem2.appendChild(line3);
    this.refElem2.appendChild(line4);

    this.viewObj.append(this.refElem1);
    this.viewObj.append(this.refElem2);
    this.createTextBoxObj();

    this.wallLneObj1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this.wallLneObj1.setAttribute('stroke', '#2d2d2e');
    this.wallLneObj1.setAttribute('stroke-width', '.5');
    this.wallLneObj1.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(10, 10)));
    this.wallLneObj1.setAttribute('id', 'fittingWallGuidLine1');
    this.wallLneObj1.setAttribute('vector-effect', 'non-scaling-stroke');
    this.viewObj.appendChild(this.wallLneObj1);

    this.wallLneObj2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this.wallLneObj2.setAttribute('stroke', '#2d2d2e');
    this.wallLneObj2.setAttribute('stroke-width', '.5');
    this.wallLneObj2.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(10, 10)));
    this.wallLneObj2.setAttribute('id', 'fittingWallGuidLine2');
    this.wallLneObj2.setAttribute('vector-effect', 'non-scaling-stroke');
    this.viewObj.appendChild(this.wallLneObj2);

    this.refElem3 = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.refElem4 = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    const line5 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line5.setAttribute('stroke', '#2d2d2e');
    line5.setAttribute('stroke-width', '0.5');
    line5.setAttribute('vector-effect', 'non-scaling-stroke');
    const line6 = line5.cloneNode();
    this.refElem3.appendChild(line5);
    this.refElem3.appendChild(line6);

    const line7 = line5.cloneNode();
    const line8 = line5.cloneNode();

    this.refElem4.appendChild(line7);
    this.refElem4.appendChild(line8);

    this.viewObj.append(this.refElem3);
    this.viewObj.append(this.refElem4);
    this.createWallTextBoxObj();
    (<HTMLInputElement>this.textboxObj.children[0]).value = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.widthmm.toString();
    this.spt = new SVGSprite(this.viewObj);

    targetNode.appendChild(this.viewObj);
    this.previouseInfo = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.clone();
  }

  /**
   *
   */
  getGuideTransform() {
    const fittingItem = this.parentObj as marietta.webcad.item.Fitting;
    const rotation = fittingItem.itemInfo.rotation < 0 ? fittingItem.itemInfo.rotation + 360 : fittingItem.itemInfo.rotation;
    const r = Math.cos(rotation * (Math.PI / 180));
    let guideTransform = '';
    const startDot = fittingItem.snapWall.startDot;
    const endDot = fittingItem.snapWall.endDot;
    let y = 0;
    const scale = marietta.webcad.WebCADGlobal.scaleSize;
    if (marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerFitting) {
      y = -(marietta.webcad.WebCADGlobal.itemManager.itemController.fittingGuide.guideLineY * 2) * (1 / scale) - marietta.webcad.WebCADGlobal.itemManager.itemController.fittingGuide.guideLinePadding * scale;
    }
    if (startDot.x < endDot.x) {
      if (startDot.y === endDot.y) {
        if (r < 0) {
          guideTransform = 'matrix(1,0,0,1,0,0)';
        } else {
          guideTransform = `matrix(-1,0,0,-1,0,${String(y)})`;
        }
      } else if (startDot.y > endDot.y) {
        if (r < 0) {
          guideTransform = 'matrix(1,0,0,1,0,0)';
        } else {
          guideTransform = `matrix(-1,0,0,-1,0,${String(y)})`;
        }
      } else {
        if (r < 0) {
          guideTransform = 'matrix(1,0,0,1,0,0)';
        } else {
          guideTransform = `matrix(-1,0,0,-1,0,${String(y)})`;
        }
      }
    } else if (startDot.x === endDot.x) {
      if (startDot.y > endDot.y) {
        if (r < 0) {
          guideTransform = `matrix(-1,0,0,-1,0,${String(y)})`;
        } else {
          guideTransform = 'matrix(1,0,0,1,0,0)';
        }
      } else {
        if (r < 0) {
          guideTransform = 'matrix(1,0,0,1,0,0)';
        } else {
          guideTransform = `matrix(-1,0,0,-1,0,${String(y)})`;
        }
      }
    } else if (startDot.x > endDot.x) {
      if (startDot.y > endDot.y) {
        if (r < 0) {
          guideTransform = 'matrix(-1,0,0,-1,0,0)';
        } else {
          guideTransform = 'matrix(1,0,0,1,0,0)';
        }
      } else {
        if (r < 0) {
          guideTransform = `matrix(-1,0,0,-1,0,${String(y)})`;
        } else {
          guideTransform = 'matrix(1,0,0,1,0,0)';
        }
      }
    } else {
      if (r < 0) {
        guideTransform = 'matrix(-1,0,0,-1,0,0)';
      } else {
        guideTransform = 'matrix(1,0,0,1,0,0)';
      }
    }
    return guideTransform;
  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    if (!this.firstDot || !this.secondDot) return;
    if (Number.isNaN(this.firstDot.x) || Number.isNaN(this.firstDot.y)) return;
    if (Number.isNaN(this.secondDot.x) || Number.isNaN(this.secondDot.y)) return;

    this.text = this.parentObj.itemInfo.widthmm.toString();
    this.lineObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(this.firstDot.x, this.firstDot.y), new marietta.core.Point(this.secondDot.x, this.secondDot.y)));

    let l1 = FittingGuide.getPerpendicularLine(this.firstDot, this.secondDot);
    this.refElem1.children[0].setAttribute('x1', String(l1.p1.x));
    this.refElem1.children[0].setAttribute('y1', String(l1.p1.y));
    this.refElem1.children[0].setAttribute('x2', String(l1.p2.x));
    this.refElem1.children[0].setAttribute('y2', String(l1.p2.y));

    let l2 = marietta.webcad.util.WebCADUtil.rotateLine(l1.p1, l1.p2, 45);
    this.refElem1.children[1].setAttribute('x1', String(l2.start.x));
    this.refElem1.children[1].setAttribute('y1', String(l2.start.y));
    this.refElem1.children[1].setAttribute('x2', String(l2.end.x));
    this.refElem1.children[1].setAttribute('y2', String(l2.end.y));

    let l3 = FittingGuide.getPerpendicularLine(this.secondDot, this.firstDot);
    this.refElem2.children[0].setAttribute('x1', String(l3.p1.x));
    this.refElem2.children[0].setAttribute('y1', String(l3.p1.y));
    this.refElem2.children[0].setAttribute('x2', String(l3.p2.x));
    this.refElem2.children[0].setAttribute('y2', String(l3.p2.y));

    let l4 = marietta.webcad.util.WebCADUtil.rotateLine(l3.p1, l3.p2, 45);
    this.refElem2.children[1].setAttribute('x1', String(l4.start.x));
    this.refElem2.children[1].setAttribute('y1', String(l4.start.y));
    this.refElem2.children[1].setAttribute('x2', String(l4.end.x));
    this.refElem2.children[1].setAttribute('y2', String(l4.end.y));
    let textPost = this.getTextBoxPosition(this.firstDot, this.secondDot);
    let textboxTransform = `matrix(-1,0,0,-1,${String(textPost.textX)},${String(textPost.textY)})`;
    this.textboxObj.setAttribute('transform', textboxTransform);
    // (<HTMLInputElement>this.textboxObj.children[0]).value = this.text;

    if ((this.parentObj as marietta.webcad.item.Fitting).snapWall && (this.parentObj as marietta.webcad.item.Fitting).snapWall !== null) {
      const fittingItem = this.parentObj as marietta.webcad.item.Fitting;
      this.viewObj.setAttribute('transform', this.getGuideTransform());
      const snapWallStartPoint: marietta.core.Point = new marietta.core.Point(fittingItem.snapWall.startDotGlobalPoint.x / marietta.webcad.WebCADGlobal.scaleSize, fittingItem.snapWall.startDotGlobalPoint.y / marietta.webcad.WebCADGlobal.scaleSize);
      const snapWallEndPoint: marietta.core.Point = new marietta.core.Point(fittingItem.snapWall.endDotGlobalPoint.x / marietta.webcad.WebCADGlobal.scaleSize, fittingItem.snapWall.endDotGlobalPoint.y / marietta.webcad.WebCADGlobal.scaleSize);
      const scale = marietta.webcad.WebCADGlobal.scaleSize;
      let y = -this.guideLineY * (1 / scale) - this.guideLinePadding * scale;
      this.wallStartGlobalPoint = snapWallStartPoint;
      this.wallEndGlobalPoint = snapWallEndPoint;
      const fittingPoint = new marietta.core.Point(fittingItem.itemInfo.x, fittingItem.itemInfo.y);
      const closestfitting = this.getClosestFitting(this.wallStartGlobalPoint, fittingPoint);
      if (closestfitting != null) {
        this.wallStartGlobalPoint = closestfitting;
      }
      const closestfitting1 = this.getClosestFitting(this.wallEndGlobalPoint, fittingPoint);
      if (closestfitting1 != null) {
        this.wallEndGlobalPoint = closestfitting1;
      }
      const dist1 = marietta.core.Point.distance(this.wallStartGlobalPoint, fittingPoint);
      this.wallText1 = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(dist1 - this.parentObj.itemInfo.width / 2)).toString();
      this.wallStartDot = new marietta.core.Point(dist1, y);
      this.wallLneObj1.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(this.wallStartDot, new marietta.core.Point(this.secondDot.x, this.wallStartDot.y)));
      const dist2 = marietta.core.Point.distance(this.wallEndGlobalPoint, fittingPoint) * -1;
      this.wallText2 = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(dist2 * -1 - this.parentObj.itemInfo.width / 2)).toString();
      this.wallEndDot = new marietta.core.Point(dist2, y);
      this.wallLneObj2.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(this.wallEndDot, new marietta.core.Point(this.firstDot.x, this.wallEndDot.y)));

      this.lineObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(this.secondDot.x, this.wallEndDot.y), new marietta.core.Point(this.firstDot.x, this.wallStartDot.y)));
      l1 = FittingGuide.getPerpendicularLine(new marietta.core.Point(this.secondDot.x, this.wallEndDot.y), new marietta.core.Point(this.firstDot.x, this.wallStartDot.y));
      this.refElem1.children[0].setAttribute('x1', String(l1.p1.x));
      this.refElem1.children[0].setAttribute('y1', String(l1.p1.y));
      this.refElem1.children[0].setAttribute('x2', String(l1.p2.x));
      this.refElem1.children[0].setAttribute('y2', String(l1.p2.y));

      l2 = marietta.webcad.util.WebCADUtil.rotateLine(l1.p1, l1.p2, 45);
      this.refElem1.children[1].setAttribute('x1', String(l2.start.x));
      this.refElem1.children[1].setAttribute('y1', String(l2.start.y));
      this.refElem1.children[1].setAttribute('x2', String(l2.end.x));
      this.refElem1.children[1].setAttribute('y2', String(l2.end.y));

      l3 = FittingGuide.getPerpendicularLine(new marietta.core.Point(this.firstDot.x, this.wallStartDot.y), new marietta.core.Point(this.secondDot.x, this.wallEndDot.y));
      this.refElem2.children[0].setAttribute('x1', String(l3.p1.x));
      this.refElem2.children[0].setAttribute('y1', String(l3.p1.y));
      this.refElem2.children[0].setAttribute('x2', String(l3.p2.x));
      this.refElem2.children[0].setAttribute('y2', String(l3.p2.y));

      l4 = marietta.webcad.util.WebCADUtil.rotateLine(l3.p1, l3.p2, 45);
      this.refElem2.children[1].setAttribute('x1', String(l4.start.x));
      this.refElem2.children[1].setAttribute('y1', String(l4.start.y));
      this.refElem2.children[1].setAttribute('x2', String(l4.end.x));
      this.refElem2.children[1].setAttribute('y2', String(l4.end.y));

      textPost = this.getTextBoxPosition(new marietta.core.Point(this.secondDot.x, this.wallEndDot.y), new marietta.core.Point(this.firstDot.x, this.wallStartDot.y));
      textboxTransform = `matrix(1,0,0,1,${String(textPost.textX)},${String(textPost.textY)}) `;
      textboxTransform += `rotate( ${180 - (this.parentObj as marietta.webcad.item.Fitting).snapWall.rotation} ) `;
      this.textboxObj.setAttribute('transform', textboxTransform);

      const l5 = FittingGuide.getPerpendicularLine(this.wallStartDot, this.wallEndDot);
      this.refElem3.children[0].setAttribute('x1', String(l5.p1.x));
      this.refElem3.children[0].setAttribute('y1', String(l5.p1.y));
      this.refElem3.children[0].setAttribute('x2', String(l5.p2.x));
      this.refElem3.children[0].setAttribute('y2', String(l5.p2.y));

      const l6 = marietta.webcad.util.WebCADUtil.rotateLine(l5.p1, l5.p2, 45);
      this.refElem3.children[1].setAttribute('x1', String(l6.start.x));
      this.refElem3.children[1].setAttribute('y1', String(l6.start.y));
      this.refElem3.children[1].setAttribute('x2', String(l6.end.x));
      this.refElem3.children[1].setAttribute('y2', String(l6.end.y));

      const l7 = FittingGuide.getPerpendicularLine(this.wallEndDot, this.wallStartDot);
      this.refElem4.children[0].setAttribute('x1', String(l7.p1.x));
      this.refElem4.children[0].setAttribute('y1', String(l7.p1.y));
      this.refElem4.children[0].setAttribute('x2', String(l7.p2.x));
      this.refElem4.children[0].setAttribute('y2', String(l7.p2.y));

      const l8 = marietta.webcad.util.WebCADUtil.rotateLine(l7.p1, l7.p2, 45);
      this.refElem4.children[1].setAttribute('x1', String(l8.start.x));
      this.refElem4.children[1].setAttribute('y1', String(l8.start.y));
      this.refElem4.children[1].setAttribute('x2', String(l8.end.x));
      this.refElem4.children[1].setAttribute('y2', String(l8.end.y));
      let wallTextPost1 = this.getTextBoxPosition(new marietta.core.Point(this.secondDot.x, this.wallEndDot.y), this.wallStartDot);
      const textboxWidth = Math.round(this.textboxWidth);
      const wallDistance1 = Math.round(marietta.core.Point.distance(new marietta.core.Point(this.secondDot.x, this.wallEndDot.y), this.wallStartDot));
      if (textboxWidth > wallDistance1) {
        let diff = textboxWidth - wallDistance1;
        const fitWidth = Math.round(marietta.core.Point.distance(new marietta.core.Point(this.firstDot.x, this.firstDot.y), new marietta.core.Point(this.secondDot.x, this.secondDot.y)));
        if (this.wallStartDot.x < this.secondDot.x) {
          diff = textboxWidth + 20;
        }
        const newPoint = marietta.webcad.util.WebCADUtil.findPointAlongLine(new marietta.core.Point(this.firstDot.x, this.wallEndDot.y), this.wallStartDot, fitWidth + diff + 10);
        wallTextPost1 = this.getTextBoxPosition(newPoint, this.wallStartDot);
      }
      /* console.log("wallTextPost1");
            console.log(wallTextPost1); */
      let wallTextboxTransform1 = `matrix(1,0,0,1,${String(wallTextPost1.textX)},${String(wallTextPost1.textY)}) `;
      wallTextboxTransform1 += `rotate( ${180 - (this.parentObj as marietta.webcad.item.Fitting).snapWall.rotation} ) `;
      this.wallTextboxObj1.setAttribute('transform', wallTextboxTransform1);
      if (Number(this.wallText1) < 0) {
        $(this.wallTextboxObj1).find('input').addClass('error');
      } else {
        $(this.wallTextboxObj1).find('input').removeClass('error');
      }
      (<HTMLInputElement>this.wallTextboxObj1.children[0]).value = this.wallText1;

      let wallTextPost2 = this.getTextBoxPosition(this.wallEndDot, new marietta.core.Point(this.firstDot.x, this.wallStartDot.y));
      const wallDistance2 = Math.round(marietta.core.Point.distance(this.wallEndDot, new marietta.core.Point(this.firstDot.x, this.wallStartDot.y)));
      if (textboxWidth > wallDistance2) {
        const diff = textboxWidth - wallDistance2;
        const fitWidth = Math.round(marietta.core.Point.distance(new marietta.core.Point(this.firstDot.x, this.firstDot.y), new marietta.core.Point(this.secondDot.x, this.secondDot.y)));
        let newPoint = marietta.webcad.util.WebCADUtil.findPointAlongLine(this.wallEndDot, new marietta.core.Point(this.firstDot.x, this.wallStartDot.y), -(diff + 10));
        if (this.wallEndDot.x > this.firstDot.x) {
          newPoint = marietta.webcad.util.WebCADUtil.findPointAlongLine(this.wallEndDot, new marietta.core.Point(this.firstDot.x, this.wallStartDot.y), (textboxWidth + 30));
        }
        wallTextPost2 = this.getTextBoxPosition(newPoint, new marietta.core.Point(this.firstDot.x, this.wallStartDot.y));
      }
      let wallTextboxTransform2 = `matrix(1,0,0,1,${String(wallTextPost2.textX)},${String(wallTextPost2.textY)}) `;
      wallTextboxTransform2 += `rotate( ${180 - (this.parentObj as marietta.webcad.item.Fitting).snapWall.rotation} ) `;
      this.wallTextboxObj2.setAttribute('transform', wallTextboxTransform2);
      if (Number(this.wallText2) < 0) {
        $(this.wallTextboxObj2).find('input').addClass('error');
      } else {
        $(this.wallTextboxObj2).find('input').removeClass('error');
      }
      (<HTMLInputElement>this.wallTextboxObj2.children[0]).value = this.wallText2;
    }
  }

  static getPerpendicularLine(start: marietta.core.Point, end: marietta.core.Point) {
    const scale = marietta.webcad.WebCADGlobal.scaleSize;
    const lp1 = marietta.webcad.util.WebCADUtil.getPointWithAngleAndDistanceFromLine(start, end, 90, 5 * (1 / scale));
    const lp2 = marietta.webcad.util.WebCADUtil.getPointWithAngleAndDistanceFromLine(start, end, -90, 5 * (1 / scale));
    return { p1: lp1, p2: lp2 };
  }

  /**
   * テキストボックスを表示
   */
  createTextBoxObj() {
    const scale = marietta.webcad.WebCADGlobal.scaleSize;
    /** 倍率 */
    const magnification = 1 / scale;
    const paddingWidth = this.textboxPadding * scale;
    let fontsize = Math.floor(this.fontSize * magnification);
    let textboxWidth = Math.floor(this.textboxWidth * magnification);
    let textboxHeight = Math.floor(this.textboxHeight * magnification);
    if (fontsize < this.MAX_FONT_SIZE) {
      fontsize = this.MAX_FONT_SIZE;
    }
    if (textboxWidth < this.textboxWidth) {
      textboxWidth = this.textboxWidth;
    }
    if (textboxHeight < this.MAX_BOX_HEIGHT) {
      textboxHeight = this.MAX_BOX_HEIGHT;
    }

    this.textboxObj = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
    this.textboxObj.setAttribute('height', (this.textboxObjHeight * magnification + this.textboxPadding * scale).toString());
    this.textboxObj.setAttribute('width', (textboxWidth + paddingWidth * 2).toString());
    const inpT = document.createElement('input');
    inpT.setAttribute('type', 'text');
    inpT.setAttribute('maxlength', '5');
    inpT.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
    inpT.setAttribute('style', `font-size:${fontsize}px;width:${textboxWidth}px;height:${textboxHeight}px;`);
    if( marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.end_item_info ){
      inpT.setAttribute('disabled', 'true' );
    }
    this.textboxObj.appendChild(inpT);
    this.textboxObj.setAttribute('id', 'fittingGuideTextbox');
    this.textboxObj.setAttribute('class', 'fittingGuideTextbox');
    this.viewObj.appendChild(this.textboxObj);
    inpT.style.lineHeight = `${textboxHeight}px`;

    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobileOrTablet) {
      // inpL.setAttribute("style", "position: fixed !important;");
      inpT.addEventListener('touchstart', this.onInputTextboxMouseDownMe, { passive: false });
    } else {
      inpT.addEventListener('mousedown', this.onInputTextboxMouseDownMe);
    }
    inpT.addEventListener('keyup', this.changeInput);
  }

  /**
   * テキストボックスを表示
   */
  createWallTextBoxObj() {
    // box左側
    const scale = marietta.webcad.WebCADGlobal.scaleSize;
    /** 倍率 */
    const magnification = 1 / scale;
    const paddingWidth = this.textboxPadding * scale;
    let fontsize = Math.floor(this.fontSize * magnification);
    let textboxWidth = Math.floor(this.textboxWidth * magnification);
    let textboxHeight = Math.floor(this.textboxHeight * magnification);
    if (fontsize < this.MAX_FONT_SIZE) {
      fontsize = this.MAX_FONT_SIZE;
    }
    if (textboxWidth < this.textboxWidth) {
      textboxWidth = this.textboxWidth;
    }
    if (textboxHeight < this.MAX_BOX_HEIGHT) {
      textboxHeight = this.MAX_BOX_HEIGHT;
    }
    this.wallTextboxObj1 = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
    this.wallTextboxObj1.setAttribute('height', (this.textboxObjHeight * magnification + this.textboxPadding * scale).toString());
    this.wallTextboxObj1.setAttribute('width', (textboxWidth + paddingWidth * 2).toString());
    const inpT = document.createElement('input');
    inpT.setAttribute('type', 'text');
    inpT.setAttribute('maxlength', '6');
    inpT.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
    inpT.setAttribute('style', `font-size:${fontsize}px;width:${textboxWidth}px;height:${textboxHeight}px;`);
    this.wallTextboxObj1.appendChild(inpT);
    this.wallTextboxObj1.setAttribute('id', 'fittingGuideWallTextbox1');
    this.wallTextboxObj1.setAttribute('class', 'fittingGuideTextbox');
    this.viewObj.appendChild(this.wallTextboxObj1);
    inpT.style.lineHeight = `${textboxHeight}px`;
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobileOrTablet) {
      // inpL.setAttribute("style", "position: fixed !important;");
      inpT.addEventListener('touchstart', this.onInputTextboxMouseDownMe, { passive: false });
    } else {
      inpT.addEventListener('mousedown', this.onInputTextboxMouseDownMe);
    }
    inpT.addEventListener('keyup', this.changeInput);

    // box右側
    this.wallTextboxObj2 = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
    this.wallTextboxObj2.setAttribute('height', (this.textboxObjHeight * magnification + this.textboxPadding * scale).toString());
    this.wallTextboxObj2.setAttribute('width', (textboxWidth + paddingWidth * 2).toString());
    const inp = document.createElement('input');
    inp.setAttribute('type', 'text');
    inp.setAttribute('maxlength', '6');
    inp.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
    inp.setAttribute('style', `font-size:${fontsize}px;width:${textboxWidth}px;height:${textboxHeight}px;`);
    this.wallTextboxObj2.appendChild(inp);
    this.wallTextboxObj2.setAttribute('id', 'fittingGuideWallTextbox2');
    this.wallTextboxObj2.setAttribute('class', 'fittingGuideTextbox');
    this.viewObj.appendChild(this.wallTextboxObj2);
    inp.style.lineHeight = `${textboxHeight}px`;
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobileOrTablet) {
      // inpL.setAttribute("style", "position: fixed !important;");
      inp.addEventListener('touchstart', this.onInputTextboxMouseDownMe, { passive: false });
    } else {
      inp.addEventListener('mousedown', this.onInputTextboxMouseDownMe);
    }
    inp.addEventListener('keyup', this.changeInput);
  }

  /**
   * テキストボックスを隠す
   */
  removeTextBoxObj() {
    if (this.textboxObj !== undefined) {
      const inputText = this.textboxObj.querySelector('input');
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobileOrTablet) {
        inputText.removeEventListener('touchstart', this.onInputTextboxMouseDownMe);
      } else {
        inputText.removeEventListener('mousedown', this.onInputTextboxMouseDownMe);
      }
      $(this.textboxObj).remove();
    }
  }

  /**
   * テキストボックスがクリックされました
   */
  onInputTextboxMouseDownMe = (e: MouseEvent & TouchEvent) => {
    if ((this.parentObj as marietta.webcad.item.Fitting).wallPreviousPlace == null || (this.parentObj as marietta.webcad.item.Fitting).wallPreviousPlace === undefined) {
      (this.parentObj as marietta.webcad.item.Fitting).onMouseDownMe(e);
    } else if (marietta.webcad.WebCADGlobal.userAgentManager.isMobileOrTablet) {
      $(e.currentTarget).focus();
      e.stopImmediatePropagation();
      e.stopPropagation();
    } else {
      e.stopPropagation();
    }
  };

  /**
   * 距離テキストボックスキーボードイベントトリガーの変更
   * @param event
   */
  changeInput = (event: KeyboardEvent) => {
    // eslint-disable-next-line func-names
    const validate = (e: any) => {
      const wallGuideId = (<HTMLElement>event.currentTarget).parentElement.getAttribute('id');
      const t = e.value;
      let ex = /^[0-9]+\.?[0-9]*$/;
      if (wallGuideId.substring(0, wallGuideId.length - 1) === 'fittingGuideWallTextbox') {
        ex = /^[0-9]|-+\.?[0-9]*$/;
      }
      if (ex.test(t) === false) {
        e.value = t.substring(0, t.length - 1);
      } else {
        const str = t.indexOf('.') >= 0 ? t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 3) : t;
        e.value = str;
        const x = parseFloat(str);

        if (wallGuideId.substring(0, wallGuideId.length - 1) !== 'fittingGuideWallTextbox') {
          if (Number.isNaN(x) || x < 0 || x > marietta.webcad.WebCADGlobal.minMaxFittingWidth.max) {
            e.value = t.substring(0, t.length - 1);
            console.log('big');
          }
        } else if (x > 100000) {
          e.value = t.substring(0, t.length - 1);
        }
      }
    };
    validate(event.currentTarget);

    const wallGuideId = (<HTMLElement>event.currentTarget).parentElement.getAttribute('id');

    if ($(event.currentTarget).val() === '') {
      $(event.currentTarget).css('border', 'solid 2px red');
    } else if (wallGuideId.substring(0, wallGuideId.length - 1) !== 'fittingGuideWallTextbox') {
      if (!$.isNumeric($(event.currentTarget).val()) || parseFloat((event.currentTarget as HTMLInputElement).value) < 0 || parseFloat((event.currentTarget as HTMLInputElement).value) > marietta.webcad.WebCADGlobal.minMaxFittingWidth.max) {
        $(event.currentTarget).css('border', 'solid 2px red');
      } else {
        $(event.currentTarget).css('border', 'solid 2px green');
      }
    } else if (!$.isNumeric($(event.currentTarget).val()) || parseFloat((event.currentTarget as HTMLInputElement).value) < 0 || parseFloat((event.currentTarget as HTMLInputElement).value) > 100000) {
      $(event.currentTarget).css('border', 'solid 2px red');
    } else {
      $(event.currentTarget).css('border', 'solid 2px green');
    }
    // Enter
    if (event.keyCode === 13) {
      event.preventDefault();
      if (wallGuideId.substring(0, wallGuideId.length - 1) !== 'fittingGuideWallTextbox' && ($(event.currentTarget).val() === '' || !$.isNumeric($(event.currentTarget).val()) || parseFloat((event.currentTarget as HTMLInputElement).value) < 0 || parseFloat((event.currentTarget as HTMLInputElement).value) > marietta.webcad.WebCADGlobal.minMaxFittingWidth.max)) {
        $(event.currentTarget).css('border', 'solid 2px red');
      } else {
        const item = this.parentObj as marietta.webcad.item.Fitting;
        if ((event.currentTarget as HTMLElement).parentElement.id === 'fittingGuideTextbox') {
          const param: any = {};
          param.fittingItem = this.parentObj as marietta.webcad.item.Fitting;
          param.previousInfo = this.previouseInfo;
          const newWidth: number = parseFloat((event.currentTarget as HTMLInputElement).value);
          item.changeSize(newWidth, item.itemInfo.heightmm, false);
          marietta.webcad.WebCADGlobal.quotationItemList.createData();
        } else if ((event.currentTarget as HTMLElement).parentElement.id === 'fittingGuideWallTextbox1') {
          const newDistance: number = parseFloat((event.currentTarget as HTMLInputElement).value);
          const dist = marietta.webcad.util.WebCADUtil.convertMMToPix(newDistance);

          let pnt;
          if (dist < 0) {
            const distance = marietta.core.Point.distance(this.wallEndGlobalPoint, this.wallStartGlobalPoint);
            const newPnt = marietta.webcad.util.WebCADUtil.findPointAlongLine(this.wallEndGlobalPoint, this.wallStartGlobalPoint, distance + Math.abs(dist));
            pnt = marietta.webcad.util.WebCADUtil.findPointAlongLine(new marietta.core.Point(newPnt.x, newPnt.y), this.wallEndGlobalPoint, item.itemInfo.width / 2);
          } else {
            // let newPnt = marietta.webcad.util.WebCADUtil.findPointAlongLine(this.wallStartGlobalPoint, this.wallEndGlobalPoint, Math.abs(dist));
            pnt = marietta.webcad.util.WebCADUtil.findPointAlongLine(this.wallStartGlobalPoint, this.wallEndGlobalPoint, item.itemInfo.width / 2 + dist);
            // pnt = marietta.webcad.util.WebCADUtil.findPointAlongLine(this.wallEndGlobalPoint, new marietta.core.Point(newPnt.x, newPnt.y), dist);
          }

          item.itemInfo.x = pnt.x;
          item.itemInfo.y = pnt.y;
        } else if ((event.currentTarget as HTMLElement).parentElement.id === 'fittingGuideWallTextbox2') {
          const newDistance: number = parseFloat((event.currentTarget as HTMLInputElement).value);
          const dist = marietta.webcad.util.WebCADUtil.convertMMToPix(newDistance);
          let pnt;
          if (dist < 0) {
            const distance = marietta.core.Point.distance(this.wallEndGlobalPoint, this.wallStartGlobalPoint);
            const newPnt = marietta.webcad.util.WebCADUtil.findPointAlongLine(this.wallStartGlobalPoint, this.wallEndGlobalPoint, distance + Math.abs(dist));
            pnt = marietta.webcad.util.WebCADUtil.findPointAlongLine(new marietta.core.Point(newPnt.x, newPnt.y), this.wallStartGlobalPoint, item.itemInfo.width / 2);
          } else {
            // let newPnt = marietta.webcad.util.WebCADUtil.findPointAlongLine(this.wallStartGlobalPoint, this.wallEndGlobalPoint, Math.abs(dist));
            pnt = marietta.webcad.util.WebCADUtil.findPointAlongLine(this.wallEndGlobalPoint, this.wallStartGlobalPoint, item.itemInfo.width / 2 + dist);
            // pnt = marietta.webcad.util.WebCADUtil.findPointAlongLine(this.wallEndGlobalPoint, new marietta.core.Point(newPnt.x, newPnt.y), dist);
          }
          item.itemInfo.x = pnt.x;
          item.itemInfo.y = pnt.y;
        }
        // eslint-disable-next-line no-self-assign
        (event.currentTarget as HTMLInputElement).blur();
        marietta.webcad.WebCADGlobal.itemManager.currentItem = marietta.webcad.WebCADGlobal.itemManager.currentItem;
        $(event.currentTarget).css('border', 'solid 2px green');
      }
    }

    event.stopPropagation();
  };

  /**
   * textBoxの中心位置を計算する関数
   * @returns object
   */
  getTextBoxPosition(firstDot: marietta.core.Point, secondDot: marietta.core.Point) {
    let scale = marietta.webcad.WebCADGlobal.scaleSize;
    if (firstDot === undefined || secondDot === undefined) return { textX: 0, textY: 0 };
    const cp = marietta.core.Point.interpolate(firstDot, secondDot, 0.5);

    if (scale < 1) scale = 1;
    const item = this.parentObj as marietta.webcad.item.Fitting;
    const width = $(this.textboxObj).find('input').width();
    const height = $(this.textboxObj).find('input').height();
    const sc: number = 1 / scale;
    const padding = Math.floor((2.5 / sc) * sc);
    let textX = cp.x;
    let textY = cp.y;
    if (item.snapWall && item.snapWall !== null) {
      // let angle = (180-(this.parentObj as marietta.webcad.item.Fitting).snapWall.rotation);
      const startDot = item.snapWall.startDot;
      const endDot = item.snapWall.endDot;
      if (startDot.x < endDot.x) {
        if (startDot.y === endDot.y) {
          textX = cp.x + width / 2;
          textY = cp.y + height / 2 + padding;
        } else if (startDot.y > endDot.y) {
          textX = cp.x + height / 2;
          textY = cp.y + width / 2 + padding;
          // text_x = cp.x + (width/2 * Math.sin(item.itemInfo.rotation));
          // text_y = text_y + Math.abs((height * Math.cos(item.itemInfo.rotation)));
        } else {
          textX = cp.x + width / 2;
          textY = cp.y - height / 2 + padding;
          // text_x = cp.x - (width/2 * Math.sin(item.itemInfo.rotation));
          // text_y = text_y - Math.abs((height * Math.sin(item.itemInfo.rotation)));
        }
      } else if (startDot.x === endDot.x) {
        if (startDot.y > endDot.y) {
          textX = cp.x - height / 2;
          textY = cp.y + width / 2;
        } else {
          textX = cp.x + height / 2;
          textY = cp.y - width / 2;
        }
      } else if (startDot.y === endDot.y) {
        textX = cp.x - width / 2;
        textY = cp.y - height / 2 - padding;
      } else if (startDot.y > endDot.y) {
        textX = cp.x - width / 2;
        textY = cp.y - height / 2 + padding;
      } else {
        textX = cp.x - width / 2;
        textY = cp.y - height / 2 - padding;
      }
    } else {
      textX = cp.x + width / 2;
    }
    return { textX, textY };
  }

  /**
   *
   * @param startDot
   * @param endDot
   * @returns
   */
  getClosestFitting(startDot: marietta.core.Point, endDot: marietta.core.Point) {
    const item = this.parentObj as marietta.webcad.item.Fitting;
    const fittingList: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, ITEM_MODE_NO.MODE_FITTING_NO).getAllChildren();
    const wallFittingPointList: marietta.core.Point[] = [];
    for (let i: number = 0; i < fittingList.length; i += 1) {
      const fittingPoint = new marietta.core.Point(fittingList[i].itemInfo.x, fittingList[i].itemInfo.y);
      let samePoint: boolean = false;
      if (fittingPoint.x === item.itemInfo.x && fittingPoint.y === item.itemInfo.y) {
        samePoint = true;
      }
      if (!samePoint) {
        // 1px = モジュールピッチ / PIX_IN_GRID 相当のため、端点を整数pxに丸めると寸法表示がmm単位でずれる
        const newPoint = marietta.webcad.util.WebCADUtil.findPointAlongLine(fittingPoint, startDot, -fittingList[i].itemInfo.width / 2);
        const isAlongWall = marietta.webcad.util.WebCADUtil.isPointInBetweenLine(startDot, endDot, newPoint);
        if (isAlongWall && (fittingList[i] as marietta.webcad.item.Fitting).snapWall != null && (fittingList[i] as marietta.webcad.item.Fitting).snapWall.index === item.snapWall.index) {
          wallFittingPointList.push(new marietta.core.Point(newPoint.x, newPoint.y));
        }
      }
    }
    if (wallFittingPointList.length > 0) {
      const nearest = wallFittingPointList.reduce((a: marietta.core.Point, b: marietta.core.Point) => {
        const aDiff = marietta.core.Point.distance(a, new marietta.core.Point(item.itemInfo.x, item.itemInfo.y));
        const bDiff = marietta.core.Point.distance(b, new marietta.core.Point(item.itemInfo.x, item.itemInfo.y));

        if (aDiff === bDiff) {
          return a > b ? a : b;
        }
        return bDiff < aDiff ? b : a;
      });
      return nearest;
    }
    return null;
  }

  /**
   * Scale fitting guide text box according to zoom while placing fitting
   */
  updateTextSize() {
    const scale = marietta.webcad.WebCADGlobal.scaleSize;
    this.textboxObj.children[0].setAttribute('style', `font-size:${this.fontSize / scale}px;width:${this.textboxWidth / scale}px;height:${this.textboxHeight / scale}px;`);
    this.textboxObj.setAttribute('height', (this.textboxObjHeight * (1 / scale) + (this.textboxPadding * scale)).toString());
    this.textboxObj.setAttribute('width', (this.textboxObjWidth * (1 / scale) + (this.textboxPadding * scale)).toString());
    this.wallTextboxObj1.children[0].setAttribute('style', `font-size:${this.fontSize / scale}px;width:${this.textboxWidth / scale}px;height:${this.textboxHeight / scale}px;`);
    this.wallTextboxObj1.setAttribute('height', (this.textboxObjHeight * (1 / scale) + (this.textboxPadding * scale)).toString());
    this.wallTextboxObj1.setAttribute('width', (this.textboxObjWidth * (1 / scale) + (this.textboxPadding * scale)).toString());
    this.wallTextboxObj2.children[0].setAttribute('style', `font-size:${this.fontSize / scale}px;width:${this.textboxWidth / scale}px;height:${this.textboxHeight / scale}px;`);
    this.wallTextboxObj2.setAttribute('height', (this.textboxObjHeight * (1 / scale) + (this.textboxPadding * scale)).toString());
    this.wallTextboxObj2.setAttribute('width', (this.textboxObjWidth * (1 / scale) + (this.textboxPadding * scale)).toString());
    this.updateTransforms();
  }
}
